module.exports = __webpack_public_path__ + "static/media/splash.72b8163b.jpg";